import React, { useEffect } from 'react';
import { useHistory, } from 'react-router';

import TenantUserPage from '../hocs/TenantUserPage';

function Contacts(props) {
  const { match: { params: { tenantPath } } } = props;
  const history = useHistory();

  useEffect(() => {
    history.push(`/${tenantPath}/inquiries/new`);
  }, []);
  return null;
}

export default TenantUserPage(Contacts);
